<template>
  <div class="car-search" @click.stop>
    <h2 class="car-search__title">Find Your Perfect Car</h2>
    <div class="car-search__container">
      <div class="car-search__box"></div>

      <!-- PC版布局 -->
      <template v-if="deviceType === 'desktop' || deviceType === 'pc'">
        <div class="car-search__inputs">
          <!-- 类型选择下拉框 -->
          <div class="car-search__input" @click.stop="toggleDropdown('type')">
            <div class="car-search__input-text">{{ selectedType.name }}</div>
            <img src="@/assets/arrow_drop_down.png" class="car-search__input-icon"
              :class="{'car-search__input-icon--rotated': activeDropdown === 'type'}" alt="">

            <!-- 类型选择下拉菜单 -->
            <div class="car-search__dropdown" v-show="activeDropdown === 'type'">
              <div class="car-search__dropdown-inner">
                <div v-for="(item, index) in types" :key="`type-${index}`"
                  class="car-search__dropdown-item"
                  :class="{'car-search__dropdown-item--active': selectedType.id === item.id}"
                  @click.stop="selectItem('type', item)">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="car-search__divider"></div>

          <!-- 价格选择下拉框 -->
          <div class="car-search__input" @click.stop="toggleDropdown('price')">
            <div class="car-search__input-text">{{ selectedPrice.name }}</div>
            <img src="@/assets/arrow_drop_down.png" class="car-search__input-icon"
              :class="{'car-search__input-icon--rotated': activeDropdown === 'price'}" alt="">

            <!-- 价格选择下拉菜单 -->
            <div class="car-search__dropdown" v-show="activeDropdown === 'price'">
              <div class="car-search__dropdown-inner">
                <div v-for="(item, index) in prices" :key="`price-${index}`"
                  class="car-search__dropdown-item"
                  :class="{'car-search__dropdown-item--active': selectedPrice.id === item.id}"
                  @click.stop="selectItem('price', item)">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="car-search__divider"></div>

          <!-- 品牌选择下拉框 -->
          <div class="car-search__input" @click.stop="toggleDropdown('brand')">
            <div class="car-search__input-text">{{ selectedBrand.name }}</div>
            <img src="@/assets/arrow_drop_down.png" class="car-search__input-icon"
              :class="{'car-search__input-icon--rotated': activeDropdown === 'brand'}" alt="">

            <!-- 品牌选择下拉菜单 -->
            <div class="car-search__dropdown" v-show="activeDropdown === 'brand'">
              <div class="car-search__dropdown-inner">
                <div v-for="(item, index) in brands" :key="`brand-${index}`"
                  class="car-search__dropdown-item"
                  :class="{'car-search__dropdown-item--active': selectedBrand.id === item.id}"
                  @click.stop="selectItem('brand', item)">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="car-search__button" @click="searchWithParams">
          <div class="car-search__button-inner">
            <img src="@/assets/search.svg" class="car-search__icon" alt="">
            <div class="car-search__button-text">Search</div>
          </div>
        </div>
      </template>

      <!-- 移动版布局 -->
      <template v-else>
        <div class="car-search__inputs-mobile">
          <!-- 类型选择下拉框 -->
          <div class="car-search__input-mobile" @click.stop="toggleDropdown('type')">
            <div class="car-search__input-text">{{ selectedType.name }}</div>
            <img src="@/assets/arrow_drop_down.png" class="car-search__input-icon"
              :class="{'car-search__input-icon--rotated': activeDropdown === 'type'}" alt="">

            <!-- 类型选择下拉菜单 -->
            <div class="car-search__dropdown-mobile" v-show="activeDropdown === 'type'">
              <div class="car-search__dropdown-inner">
                <div v-for="(item, index) in types" :key="`type-${index}`"
                  class="car-search__dropdown-item"
                  :class="{'car-search__dropdown-item--active': selectedType.id === item.id}"
                  @click.stop="selectItem('type', item)">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>

          <!-- 价格选择下拉框 -->
          <div class="car-search__input-mobile" @click.stop="toggleDropdown('price')">
            <div class="car-search__input-text">{{ selectedPrice.name }}</div>
            <img src="@/assets/arrow_drop_down.png" class="car-search__input-icon"
              :class="{'car-search__input-icon--rotated': activeDropdown === 'price'}" alt="">

            <!-- 价格选择下拉菜单 -->
            <div class="car-search__dropdown-mobile" v-show="activeDropdown === 'price'">
              <div class="car-search__dropdown-inner">
                <div v-for="(item, index) in prices" :key="`price-${index}`"
                  class="car-search__dropdown-item"
                  :class="{'car-search__dropdown-item--active': selectedPrice.id === item.id}"
                  @click.stop="selectItem('price', item)">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>

          <!-- 品牌选择下拉框 -->
          <div class="car-search__input-mobile" @click.stop="toggleDropdown('brand')">
            <div class="car-search__input-text">{{ selectedBrand.name }}</div>
            <img src="@/assets/arrow_drop_down.png" class="car-search__input-icon"
              :class="{'car-search__input-icon--rotated': activeDropdown === 'brand'}" alt="">

            <!-- 品牌选择下拉菜单 -->
            <div class="car-search__dropdown-mobile" v-show="activeDropdown === 'brand'">
              <div class="car-search__dropdown-inner">
                <div v-for="(item, index) in brands" :key="`brand-${index}`"
                  class="car-search__dropdown-item"
                  :class="{'car-search__dropdown-item--active': selectedBrand.id === item.id}"
                  @click.stop="selectItem('brand', item)">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>

          <!-- 移动版搜索按钮 -->
          <div class="car-search__button-mobile" @click="searchWithParams">
            <div class="car-search__button-inner">
              <img src="@/assets/search.svg" class="car-search__icon" alt="">
              <div class="car-search__button-text">Search</div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CarSearch',
  computed: {
    ...mapGetters({
      deviceType: 'deviceType'
    })
  },
  data () {
    return {
      activeDropdown: null, // 当前展开的下拉菜单

      // 车型类型数据
      types: [
        { id: 'all-types', name: 'All Types' },
        { id: 'Sedan', name: 'Sedan' },
        { id: 'SUV', name: 'SUV' },
        { id: 'Coupe', name: 'Coupe' },
        { id: 'Hatchback', name: 'Hatchback' },
        { id: 'Wagon', name: 'Wagon' },
        { id: 'Pickup Truck', name: 'Pickup Truck' },
        { id: 'Van', name: 'Van' },
        { id: 'Convertible', name: 'Convertible' }
      ],
      selectedType: { id: 'all-types', name: 'All Types' },

      // 价格范围数据
      prices: [
        { id: 'all-prices', name: 'All Ex-Showroom Price' },
        { id: 'less_20000', name: 'Less than $20,000' },
        { id: '20001_40000', name: '$20,001 - $40,000' },
        { id: '40001_60000', name: '$40,001 - $60,000' },
        { id: '60001_80000', name: '$60,001 - $80,000' },
        { id: 'more_80001', name: 'More than $80,000' }
      ],
      selectedPrice: { id: 'all-prices', name: 'All Ex-Showroom Price' },

      // 品牌数据
      brands: [
        { id: 'all-brands', name: 'All Brands' },
        { id: 'Acura', name: 'Acura' },
        { id: 'Alfa Romeo', name: 'Alfa Romeo' },
        { id: 'Aston Martin', name: 'Aston Martin' },
        { id: 'Audi', name: 'Audi' },
        { id: 'Bentley', name: 'Bentley' },
        { id: 'BMW', name: 'BMW' },
        { id: 'Buick', name: 'Buick' },
        { id: 'Cadillac', name: 'Cadillac' },
        { id: 'Chevrolet', name: 'Chevrolet' },
        { id: 'Chrysler', name: 'Chrysler' },
      ],
      selectedBrand: { id: 'all-brands', name: 'All Brands' }
    }
  },
  mounted () {
    // 添加点击外部关闭下拉菜单事件
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeDestroy () {
    // 移除事件监听
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    // 处理点击组件外部事件
    handleOutsideClick (event) {
      // 如果点击的不是组件内部元素，则关闭所有下拉菜单
      if (!this.$el.contains(event.target)) {
        this.closeDropdowns();
      }
    },

    // 切换下拉菜单显示状态
    toggleDropdown (type) {
      event.stopPropagation(); // 阻止事件冒泡

      // 切换下拉菜单状态
      if (this.activeDropdown === type) {
        this.activeDropdown = null;
      } else {
        this.activeDropdown = type;
      }

      console.log('当前激活的下拉菜单:', this.activeDropdown);
    },

    // 关闭所有下拉菜单
    closeDropdowns () {
      this.activeDropdown = null;
    },

    // 选择菜单项
    selectItem (type, item) {
      switch (type) {
        case 'type':
          this.selectedType = item;
          break;
        case 'price':
          this.selectedPrice = item;
          break;
        case 'brand':
          this.selectedBrand = item;
          break;
      }

      // 阻止事件冒泡
      event.stopPropagation();

      console.log(`已选择 ${type}: `, item.name);

      // 关闭当前下拉菜单
      this.activeDropdown = null;
    },

    // 搜索功能
    searchWithParams () {
      const searchParams = {};

      // 如果选择了类型，添加到搜索参数
      if (this.selectedType.id !== 'all-types') {
        searchParams.type = this.selectedType.id;
      }

      // 如果选择了价格区间，添加到搜索参数
      if (this.selectedPrice.id !== 'all-prices') {
        // 根据价格ID设置对应的价格参数
        const priceId = this.selectedPrice.id;
        switch (priceId) {
          case 'less_20000':
            searchParams.mostPrice = 20000;
            break;
          case '20001_40000':
            searchParams.leastPrice = 20001;
            searchParams.mostPrice = 40000;
            break;
          case '40001_60000':
            searchParams.leastPrice = 40001;
            searchParams.mostPrice = 60000;
            break;
          case '60001_80000':
            searchParams.leastPrice = 60001;
            searchParams.mostPrice = 80000;
            break;
          case 'more_80001':
            searchParams.leastPrice = 80001;
            break;
        }
      }

      // 如果选择了品牌，添加到搜索参数
      if (this.selectedBrand.id !== 'all-brands') {
        searchParams.brand = this.selectedBrand.id;
      }

      console.log('搜索参数:', searchParams);

      // 获取当前路由的channel参数和其他自定义查询参数
      const currentQuery = { ...this.$route.query };

      // 合并当前查询参数和搜索参数 (搜索参数优先)
      const finalQuery = { ...currentQuery, ...searchParams };

      console.log('最终查询参数:', finalQuery);

      // 检查是否存在channel参数
      if (this.$route.params.channel) {
        // 如果有channel参数，使用完整路径
        const channelPath = `/${this.$route.params.channel}/car-list`;
        window.location.href = `${channelPath}?${new URLSearchParams(finalQuery).toString()}`;
      } else {
        // 使用路由导航到car-list页面并传递参数
        this.$router.push({
          path: '/car-list',
          query: finalQuery
        });
      }
    },

    // API调用方法（如果需要在组件内直接调用）
    searchCars () {
      // 示例：调用搜索API
      // this.$global.server.searchCars(params)
      //   .then(res => {
      //     // 处理结果
      //   })
      //   .catch(err => {
      //     console.error('搜索出错:', err);
      //   });
    }
  }
}
</script>

<style lang="scss" >
@import '~@/css/variables.scss';

.car-search {
	display: flex;
	flex-direction: column;
	gap: rem(50);
	align-items: center;
	justify-content: flex-start;
	position: relative;
	padding-top: rem(80);
	padding-bottom: rem(344);

	&__title {
		color: #ffffff;
		text-align: center;

		font-size: rem(50);
		line-height: rem(50);
		font-weight: 700;
		position: relative;
		align-self: stretch;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	&__container {
		flex-shrink: 0;
		width: rem(790);
		height: rem(56);
		position: relative;
	}

	&__box {
		background: #ffffff;
		border-radius: rem(12);
		width: rem(790);
		height: rem(56);
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		top: 0;
	}

	&__button {
		background: #ffffff;
		border-radius: rem(12);
		padding: rem(6);
		display: flex;
		flex-direction: column;
		gap: rem(10);
		align-items: flex-start;
		justify-content: flex-start;
		width: rem(188);
		height: rem(56);
		position: absolute;
		right: 0;
		top: 0;
		cursor: pointer;
		z-index: 5;
	}

	&__button-inner {
		background: #405ff2;
		border-radius: rem(12);
		padding: rem(13) rem(33);
		display: flex;
		flex-direction: row;
		gap: rem(10);
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		width: rem(176);
		height: rem(44);
		position: relative;
	}

	&__icon {
		flex-shrink: 0;
		width: rem(16);
		height: rem(16);
		position: relative;
		overflow: visible;
	}

	&__button-text {
		color: #ffffff;
		text-align: left;

		font-size: rem(16);
		line-height: rem(16);
		font-weight: 700;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	&__inputs {
		display: flex;
		flex-direction: row;
		gap: 0;
		align-items: center;
		justify-content: flex-start;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 5;
	}

	&__input {
		background: rgba(255, 255, 255, 0);
		border-radius: rem(12);
		padding: rem(21) rem(20);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		flex-shrink: 0;
		width: rem(200);
		height: rem(56);
		position: relative;
		cursor: pointer;
	}

	&__input-text {
		color: #050b20;
		text-align: left;

		font-size: rem(12);
		line-height: rem(12);
		font-weight: 400;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	&__input-icon {
		flex-shrink: 0;
		width: rem(12);
		height: rem(12);
		position: relative;
		overflow: visible;
		transition: transform 0.3s ease;

		&--rotated {
			transform: rotate(180deg);
		}
	}

	&__divider {
		background: #050b20;
		opacity: 0.1;
		flex-shrink: 0;
		width: rem(1);
		height: rem(24);
		position: relative;
	}

	&__dropdown {
		position: absolute;
		top: 100%;
		left: 0;
		width: rem(200);
		background: #ffffff;
		border-radius: rem(4);
		box-shadow: 0 rem(2) rem(8) rgba(0, 0, 0, 0.16);
		z-index: 10;
		max-height: rem(300);
		overflow-y: auto;
		&::-webkit-scrollbar {
			display: none; /* Chrome Safari */
		}
	}

	&__dropdown-inner {
		display: flex;
		flex-direction: column;
		width: 100%;
	}

	&__dropdown-item {
		padding: rem(14) rem(20);
		color: #050b20;

		font-size: rem(12);
		line-height: rem(12);
		font-weight: 400;
		border-bottom: rem(1) solid #e9e9e9;
		cursor: pointer;

		&:last-child {
			border-bottom: none;
		}

		&:hover {
			background: rgba(#405ff2, 0.05);
		}

		&--active {
			color: #405ff2;

			font-weight: 500;
		}
	}

	// 移动端版本样式
	&__inputs-mobile {
		display: flex;
		flex-direction: column;
		gap: rem(4);
		align-items: flex-start;
		justify-content: center;
		position: absolute;
		left: rem(10);
		top: rem(10);
		width: calc(100% - rem(20));
		z-index: 5;
	}

	&__input-mobile {
		background: #ffffff;
		border-radius: rem(12);
		padding: rem(16) rem(20);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		position: relative;
		cursor: pointer;
	}

	&__dropdown-mobile {
		position: absolute;
		top: 100%;
		left: 0;
		width: 100%;
		background: #ffffff;
		border-radius: rem(4);
		box-shadow: 0 rem(2) rem(8) rgba(0, 0, 0, 0.16);
		z-index: 10;
		max-height: rem(200);
		overflow-y: auto;
		margin-top: rem(4);
		&::-webkit-scrollbar {
			display: none; /* Chrome Safari */
		}
	}

	&__button-mobile {
		background: #405ff2;
		border-radius: rem(12);
		margin-top: rem(4);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: rem(44);
		position: relative;
		cursor: pointer;
		z-index: 5;
	}
}

// 响应式样式 - 从home.scss和main.scss中移植
// PC 设备类
.detect_deviece_pc,
.detect_deviece_desktop {
	.car-search {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);

		&__container {
			width: rem(790);
			height: rem(56);
		}

		&__box {
			width: rem(790);
			height: rem(56);
		}
	}
}

// Mobile 设备类
.detect_deviece_mobile {
	.car-search {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);
		padding-top: rem(50);
		padding-bottom: rem(274);
		gap: rem(20);

		&__title {
			font-size: rem(50);
			font-style: normal;
			font-weight: 700;
			line-height: rem(60); /* 120% */
		}
		&__button-mobile {
			margin-top: rem(6);
		}
		&__container {
			width: rem(343);
			height: rem(214);
		}

		&__box {
			background: #ffffff;
			border-radius: rem(12);
			opacity: 0.2;
			width: rem(343);
			height: rem(214);
		}
	}
}
</style>
